import axios from 'axios';
import { AuthenticationDetails, CognitoUser, CognitoUserPool } from 'amazon-cognito-identity-js';

class ApiManager {
  constructor(user, session, onLogoutCallback, onErrorCallback) {
    this.cognitoUser = user;
    this.session = session;
    this.onLogoutCallback = onLogoutCallback;
    this.onError = onErrorCallback;
    this.accessToken = session?.idToken?.jwtToken;
    this.apiBaseUrl = 'https://api.overpower.tv'; // Reemplaza con la URL base de tu API Gateway
    this.release = true;
  }

  
  async callApiEndpoint(endpoint, method = 'GET', data = null, notifyError = true) {
    try {
      if (this.session != undefined){
      const response = await this.checkTokenAndRefreshIfNeeded(async () => {
        return await axios({
          method,
          url: this.release? `${this.apiBaseUrl}/${endpoint}` : `${this.apiBaseUrl}/test/${endpoint}`,
          headers: {
            Authorization: `Bearer ${this.accessToken}`,
          },
          data,
        });
      });

      return response.data;
      }
      else {
        const response =  await axios({
          method,
          url: this.release? `${this.apiBaseUrl}/${endpoint}` : `${this.apiBaseUrl}/test/${endpoint}`,
          data,
        });
        return response.data;
      }
    } catch (error) {
      if (notifyError)
      {
        if (this.onError !== null && (error.response?.status == 500 || error.response?.status == 400)) {
          this.onError("Error: " + error.response.data.message, error.response.data.err);
        }
        else if (this.onError !== null && error.response?.status == 404) {
          this.onError("Error: Operacion Invalidad", "El elemento que intento modificar no fue encontrado en el servidor.");
        }
        else if (this.onError !== null && error.response?.status == 403) {
          this.onError("Error: Operacion no authorizada", "Usted no tiene permisos para realizar esta modificion.");
        }
        else {
          this.onLogoutCallback();
          this.onError("Sesión expirada expirada", "Su sesión fue cerrada por inactividad o devido a una operacion invalida.");
        }
      }
      return null;
    }
  }

  // GetEvents is a method to get all public events that are in published state for display.
  async GetEvents(eventStatus = 1)
  {
    if (eventStatus <= 0)
    {
      return null;
    }
    return await this.callApiEndpoint(`events?status=${eventStatus}`);
  }

  // Obtener actividades de un evento específico
async GetEventActivities(eventID) {
  if (!eventID) return null;

  // Llama a tu endpoint Lambda vía API Gateway
  return await this.callApiEndpoint(`events/${eventID}/activities`, "GET", null, true);
}

async GetEventPartner(eventID) {
  if (!eventID) return null;

  // Llama a tu endpoint Lambda vía API Gateway
  return await this.callApiEndpoint(`events/${eventID}/partners`, "GET", null, true);
}

  async GetEventDetails(eventID) {  
    return await this.callApiEndpoint(`events?id=${eventID}`);
  }
   async GetEventNews(eventID) {
    if (!eventID) return null;
    console.log(`🔄 Llamando a API: events/${eventID}/News`);
    return await this.callApiEndpoint(`events/${eventID}/News`, "GET", null, true);
  }
async RegisterParticipant(eventActivityID) {
  if (!eventActivityID) return null;
  
  return await this.callApiEndpoint(
    `registerParticipant`, 
    "POST", 
    { "EventActivityID": eventActivityID }, 
    true
  );
}
  // Adjustments related functions
  async GetUserData() {
    return await this.callApiEndpoint("userData");
  }
    async GetUserPublic(email) {
    return await this.callApiEndpoint(`usersPublic?user=${email}`);
  }
  async GetPublications() {
      return await this.callApiEndpoint("publications");
    }
  async GetPublicationsByCreator(IDCreator) {
    return await this.callApiEndpoint(`publications?IDCreator=${IDCreator}`);
  }
  async postPublish(item){
    return await this.callApiEndpoint("publications", "POST", item);
  }
  async GetCreator(IDCreator) {
      return await this.callApiEndpoint(`creators?IDCreator=${IDCreator}`);
    }
  async GetCreatorByNickname(Nickname) {
      return await this.callApiEndpoint(`creators?nickname=${Nickname}`);
    }
  async GetImageURL(Path) {
      return await this.callApiEndpoint(`image?img=${Path}`);
    }
  async GetPublicationLike(PublicationID) {
      return await this.callApiEndpoint(`publicationLikes?publicationID=${PublicationID}`,"GET",null,false);
    }
  async PostPublicationLike(PublicationID) {
      return await this.callApiEndpoint(`publicationLikes?publicationID=${PublicationID}`, "POST");
    }
  async DeletePublicationLike(PublicationID) {
      return await this.callApiEndpoint(`publicationLikes?publicationID=${PublicationID}`, "DELETE");
    }
    async GetPublication(PublicationID) {
    return await this.callApiEndpoint(`publications?publicationID=${PublicationID}`);
  }

  async GetAvatarUploadUrl(blob, filename)
  {
    const {uploadUrl, key} = await this.callApiEndpoint(`avatarUrl?action=post`);
    return {uploadUrl, key};
  }

  // comments
   async GetComments(PublicationID, limit=10, order="desc", lastKey=null, replyTo=null) {
      if (lastKey != null)
        return await this.callApiEndpoint(`comments?publicationID=${PublicationID}&limit=${limit}&order=${order}&lastKey=${lastKey}`,"GET",null,false);
      else if (replyTo != null)
        return await this.callApiEndpoint(`comments?publicationID=${PublicationID}&limit=${limit}&order=${order}&replyTo=${replyTo}`,"GET",null,false);
      else
        return await this.callApiEndpoint(`comments?publicationID=${PublicationID}&limit=${limit}&order=${order}`,"GET",null,false);
    }

  async PostComment(PublicationID, Comment) {
      return await this.callApiEndpoint(`comments?publicationID=${PublicationID}`, "POST", Comment);
    }

  async DeleteComment(PublicationID, CommentID) {
      return await this.callApiEndpoint(`comments?publicationID=${PublicationID}&commentID=${CommentID}`, "DELETE");
  }

  //Acá empieza la funcion de Aguinaldos/ChristmasBonus:

  async checkTokenAndRefreshIfNeeded(calledAction) {
    if (this.session.getRefreshToken === undefined) return;
    const refreshToken = this.session.getRefreshToken();
    const now = Math.floor(new Date() / 1000);
    const isAccessTokenExpired = this.session.getAccessToken().getExpiration() < now;

    if (isAccessTokenExpired) {
      console.log('Access token has expired, refreshing...');
      return new Promise((resolve, reject) => {
        this.cognitoUser.refreshSession(refreshToken, async (err, session) => {
          if (err) {
            console.error('Token refresh failed:', err);
            return reject(new Error('Token refresh failed!'));
          } else {
            this.session = session;
            this.accessToken = this.session.getAccessToken().getJwtToken();
            console.log('Token was successfully refreshed.');
            resolve(await calledAction());
          }
        });
      });
    } else {
      return await calledAction();
    }
  }
}

export default ApiManager;